module.exports = __webpack_public_path__ + "340717d1347b9598242d5bd34f0fd3a5.png";